export default "__VITE_ASSET__CXlBtIlC__"